import isDev from './isDev';

import isBeta from './isBeta';

import isProd from './isProd';

import isTest from './isTest';

import transformUrlToCurrentEnv from './transformUrlToCurrentEnv';

import webviewConsole from './webviewConsole';

import createUrlWithQuery from './createUrlWithQuery';

import getParams from './getParams';

import addParam from './addParam';

import removeParam from './removeParam';

import getCookie from './getCookie';

import digy from './digy';

import digyAndHm from './digyAndHm';

import useDevTool from './useDevTool';

const DtTools = {
  isDev,
  isBeta,
  isProd,
  isTest,
  transformUrlToCurrentEnv,
  webviewConsole,
  createUrlWithQuery,
  getParams,
  addParam,
  removeParam,
  getCookie,
  digy,
  digyAndHm,
  useDevTool,
};

export default DtTools;
